export default __webpack_public_path__ + "static/media/2274.73335098.png";